import * as modules from "./modules/";
import config from "../../../../config";
const { vendor } = config;

const AlertManagement = modules[vendor] ? modules[vendor] : modules["default"];

export default AlertManagement;
